var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksArrowTop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 85,
    viewBox: "0 0 539 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 85V9C5 6.79086 6.79086 5 9 5H530C532.209 5 534 6.79086 534 9V85",
    stroke: "url(#paint0_linear_330_1685)",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 85V9C5 6.79086 6.79086 5 9 5H530C532.209 5 534 6.79086 534 9V85",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    strokeDasharray: "15 15"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_330_1685",
    x1: 5,
    y1: 45,
    x2: 35.4971,
    y2: -130.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F64E4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksArrowTop);
export default __webpack_public_path__ + "static/media/howItWorks_arrow_top.13db78b92fd18da9215dcc7154e4fa52.svg";
export { ForwardRef as ReactComponent };